import type { FeedbackStatus } from '@/shared/domain'
import { Badge } from '@/shared/ui/primitives'

type BadgeMeta = {
  label: string
  variant: 'outline' | 'info' | 'success'
}

const STATUS_META: Record<FeedbackStatus, BadgeMeta> = {
  submitted: { label: 'Submitted', variant: 'outline' },
  reviewing: { label: 'In review', variant: 'info' },
  resolved: { label: 'Resolved', variant: 'success' },
}

export type FeedbackStatusBadgeProps = {
  status: FeedbackStatus
}

export function FeedbackStatusBadge({ status }: FeedbackStatusBadgeProps) {
  const meta = STATUS_META[status]
  return <Badge variant={meta.variant}>{meta.label}</Badge>
}
